<template>
    <el-dialog :model-value="visibleModel" class="subtitle-selection-dialog"
        modal-class="subtitle-selection-dialog-modal"
        :title="isMobile ? undefined : (mode === 'precision' ? t('tools.subtitleEraseDialogTitle') : t('tools.subtitleEraseDialogTitleSimple'))"
        :width="dialogWidth" :show-close="!isMobile" align-center destroy-on-close @close="handleClose">
        <!-- 移动端自定义标题栏 -->
        <template v-if="isMobile" #header="{ close }">
            <div class="mobile-header">
                <div class="mobile-header-left">
                    <span class="mobile-title">
                        {{
                            mode === 'precision'
                                ? t('tools.subtitleEraseDialogTitle')
                                : t('tools.subtitleEraseDialogTitleSimple')
                        }}
                    </span>
                </div>
                <div class="mobile-header-right">
                    <!-- 顶部操作区域 - 移动端 -->
                    <div v-if="mode === 'precision'" class="toolbar-group mobile-toolbar">
                        <button class="toolbar-text-btn" type="button" :disabled="!selectionHistory.length"
                            @click="clearSelections">
                            <span class="icon i-clear-all-icon"></span>
                            <span>{{ t('tools.resetSelection') }}</span>
                        </button>
                        <button class="toolbar-icon-btn" type="button" :disabled="!canUndo" @click="undoSelection"
                            :title="t('tools.undoSelection')">
                            <span class="icon i-back-icon"></span>
                        </button>
                        <button class="toolbar-icon-btn" type="button" :disabled="!canRedo" @click="redoSelection"
                            :title="t('tools.redoSelection')">
                            <span class="icon i-go-icon"></span>
                        </button>
                    </div>
                    <button class="mobile-close-btn" @click="close">
                        <el-icon>
                            <Close />
                        </el-icon>
                    </button>
                </div>
            </div>
        </template>

        <div class="dialog-body" v-if="videoUrl">
            <!-- 顶部操作区域 - PC端 -->
            <div v-if="mode === 'precision' && !isMobile" class="editor-toolbar">
                <div class="toolbar-group">
                    <button class="toolbar-text-btn" type="button" :disabled="!selectionHistory.length"
                        @click="clearSelections">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M6.52571 16.6667C6.18252 17.6377 5.25649 18.3334 4.16797 18.3334C2.78726 18.3334 1.66797 17.2142 1.66797 15.8334C1.66797 14.7449 2.36364 13.8188 3.33464 13.4757V6.52449C2.36364 6.1813 1.66797 5.25526 1.66797 4.16675C1.66797 2.78604 2.78726 1.66675 4.16797 1.66675C5.25649 1.66675 6.18252 2.36242 6.52571 3.33341H13.4769C13.8201 2.36242 14.7461 1.66675 15.8346 1.66675C17.2154 1.66675 18.3346 2.78604 18.3346 4.16675C18.3346 5.25526 17.639 6.1813 16.668 6.52449V13.4757C17.639 13.8188 18.3346 14.7449 18.3346 15.8334C18.3346 17.2142 17.2154 18.3334 15.8346 18.3334C14.7461 18.3334 13.8201 17.6377 13.4769 16.6667H6.52571ZM6.52571 15.0001H13.4769C13.728 14.2897 14.291 13.7267 15.0013 13.4757V6.52449C14.291 6.27342 13.728 5.71042 13.4769 5.00008H6.52571C6.27464 5.71042 5.71164 6.27342 5.0013 6.52449V13.4757C5.71164 13.7267 6.27464 14.2897 6.52571 15.0001ZM4.16797 5.00008C4.6282 5.00008 5.0013 4.62698 5.0013 4.16675C5.0013 3.70651 4.6282 3.33341 4.16797 3.33341C3.70774 3.33341 3.33464 3.70651 3.33464 4.16675C3.33464 4.62698 3.70774 5.00008 4.16797 5.00008ZM15.8346 5.00008C16.2949 5.00008 16.668 4.62698 16.668 4.16675C16.668 3.70651 16.2949 3.33341 15.8346 3.33341C15.3744 3.33341 15.0013 3.70651 15.0013 4.16675C15.0013 4.62698 15.3744 5.00008 15.8346 5.00008ZM15.8346 16.6667C16.2949 16.6667 16.668 16.2937 16.668 15.8334C16.668 15.3732 16.2949 15.0001 15.8346 15.0001C15.3744 15.0001 15.0013 15.3732 15.0013 15.8334C15.0013 16.2937 15.3744 16.6667 15.8346 16.6667ZM4.16797 16.6667C4.6282 16.6667 5.0013 16.2937 5.0013 15.8334C5.0013 15.3732 4.6282 15.0001 4.16797 15.0001C3.70774 15.0001 3.33464 15.3732 3.33464 15.8334C3.33464 16.2937 3.70774 16.6667 4.16797 16.6667Z"
                                :fill="selectionHistory.length ? '#FFF' : '#999999'
                                    " />
                        </svg>
                        <span>{{ t('tools.resetSelection') }}</span>
                    </button>
                    <button class="toolbar-icon-btn" type="button" :disabled="!canUndo" @click="undoSelection"
                        :title="t('tools.undoSelection')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M5.82843 6.99955L8.36396 9.5351L6.94975 10.9493L2 5.99955L6.94975 1.0498L8.36396 2.46402L5.82843 4.99955H13C17.4183 4.99955 21 8.58127 21 12.9996C21 17.4178 17.4183 20.9996 13 20.9996H4V18.9996H13C16.3137 18.9996 19 16.3133 19 12.9996C19 9.68585 16.3137 6.99955 13 6.99955H5.82843Z"
                                :fill="canUndo ? '#FFF' : '#999999'" />
                        </svg>
                    </button>
                    <button class="toolbar-icon-btn" type="button" :disabled="!canRedo" @click="redoSelection"
                        :title="t('tools.redoSelection')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M18.1716 6.99955H11C7.68629 6.99955 5 9.68585 5 12.9996C5 16.3133 7.68629 18.9996 11 18.9996H20V20.9996H11C6.58172 20.9996 3 17.4178 3 12.9996C3 8.58127 6.58172 4.99955 11 4.99955H18.1716L15.636 2.46402L17.0503 1.0498L22 5.99955L17.0503 10.9493L15.636 9.5351L18.1716 6.99955Z"
                                :fill="canRedo ? '#FFF' : '#999999'" />
                        </svg>
                    </button>
                </div>
            </div>

            <!-- 中间视频显示区 -->
            <div class="video-preview">
                <div ref="videoContainer" class="video-frame-container" :style="videoAspectStyle">
                    <video ref="videoElement" :src="videoUrl" playsinline webkit-playsinline crossorigin="anonymous"
                        class="preview-video" @loadedmetadata="onVideoLoaded" @timeupdate="updateVideoProgress"
                        @play="isPlaying = true" @pause="isPlaying = false"></video>
                    <canvas v-if="mode === 'precision'" ref="selectionCanvas" class="selection-canvas"
                        @mousedown="startSelection" @mousemove="onCanvasMouseMove" @mouseup="endSelection"
                        @mouseleave="endSelection" @touchstart.prevent="startSelectionTouch"
                        @touchmove.prevent="onCanvasTouchMove" @touchend="endSelection"></canvas>
                </div>
            </div>

            <!-- 下方进度条 -->
            <div class="video-controls-bar">
                <button class="play-pause-btn" type="button" @click="togglePlayPause">
                    <svg v-if="isPlaying" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40"
                        fill="none" class="control-icon">
                        <path
                            d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                            fill="white" fill-opacity="0.1" />
                        <rect x="22.833" y="12.0667" width="4.66667" height="15.8667" rx="2.33333" fill="white" />
                        <rect x="12.5" y="12.0667" width="4.66667" height="15.8667" rx="2.33333" fill="white" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 41 40"
                        fill="none" class="control-icon">
                        <path
                            d="M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.9543 31.5457 0 20.5 0C9.4543 0 0.5 8.9543 0.5 20C0.5 31.0457 9.4543 40 20.5 40Z"
                            fill="white" fill-opacity="0.1" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M26.6952 22.1299L19.3085 26.6627C17.6427 27.6848 15.501 26.4863 15.501 24.5318V15.4663C15.501 13.512 17.6427 12.3134 19.3085 13.3355L26.6952 17.8683C28.2852 18.8439 28.2852 21.1543 26.6952 22.1299Z"
                            fill="white" />
                    </svg>
                </button>
                <div class="custom-progress-bar" @click="handleProgressClick">
                    <div class="progress-track">
                        <div class="progress-fill" :style="{ width: videoProgressPercent + '%' }"></div>
                        <div class="progress-thumb" :style="{ left: videoProgressPercent + '%' }"
                            @mousedown="startDrag"></div>
                    </div>
                </div>
                <span class="progress-text">{{ currentTime }}</span>
                <span class="progress-time">/{{ totalTime }}</span>
            </div>

            <!-- 下方选中区域列表 -->
            <div v-if="mode === 'precision'" class="selection-summary">
                <div class="summary-header">
                    <span>{{ t('tools.selectedEraseAreas') }}</span>
                </div>
                <div v-if="!selectionHistory.length" class="summary-empty">
                    {{ t('tools.noSelectionYet') }}
                </div>
                <ul v-else class="summary-list">
                    <li v-for="(item, index) in selectionHistory" :key="item.timestamp" class="summary-item">
                        <span class="summary-index">{{ index + 1 }}</span>
                        <span class="summary-coords">
                            X: {{ item.spatial.x.toFixed(1) }} · Y:
                            {{ item.spatial.y.toFixed(1) }} · W:
                            {{ item.spatial.width.toFixed(1) }} · H:
                            {{ item.spatial.height.toFixed(1) }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleClose">{{
                    t('common.cancel')
                    }}</el-button>
                <el-button type="primary" @click="handleConfirm">
                    {{
                        mode === 'precision'
                            ? t('tools.confirmSelection')
                            : t('common.confirm')
                    }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup lang="ts">
import {
    computed,
    reactive,
    ref,
    watch,
    nextTick,
    onBeforeUnmount,
    onMounted,
} from 'vue'
import { Close } from '@element-plus/icons-vue'
import { useI18n } from '~/composables/useI18n'

interface SelectionData {
    spatial: {
        x: number
        y: number
        width: number
        height: number
    }
    timestamp: number
}

const props = defineProps<{
    visible: boolean
    videoUrl: string
    mode: 'oneClick' | 'precision'
    selections?: SelectionData[]
}>()

const emit = defineEmits<{
    (e: 'update:visible', value: boolean): void
    (
        e: 'confirm',
        payload: { selections: SelectionData[]; duration: number }
    ): void
}>()

const { t } = useI18n()

const visibleModel = computed({
    get: () => props.visible,
    set: value => emit('update:visible', value),
})

const videoElement = ref<HTMLVideoElement>()
const videoContainer = ref<HTMLElement>()
const selectionCanvas = ref<HTMLCanvasElement>()

const videoDuration = ref(0)
const currentTime = ref('00:00')
const totalTime = ref('00:00')
const videoProgressPercent = ref(0)
const isPlaying = ref(false)
const isDragging = ref(false)

const videoWidth = ref(0)
const videoHeight = ref(0)

// 移动端检测
const isMobile = ref(false)
const checkMobile = () => {
    isMobile.value = typeof window !== 'undefined' && window.innerWidth < 768
}

// 对话框宽度（移动端使用100%宽度）
const dialogWidth = computed(() => {
    return isMobile.value ? '100%' : '960px'
})

const selectionHistory = ref<SelectionData[]>([])
const selectionRedoStack = ref<SelectionData[]>([])
const selectionStartDisplay = reactive({ x: 0, y: 0 })
const currentDisplayRect = reactive({ x: 0, y: 0, width: 0, height: 0 })
const currentActualRect = reactive({ x: 0, y: 0, width: 0, height: 0 })
const isSelecting = ref(false)

let canvasCtx: CanvasRenderingContext2D | null = null
let resizeObserver: ResizeObserver | null = null
let dragMoveHandler: ((event: MouseEvent) => void) | null = null
let dragUpHandler: (() => void) | null = null

const canUndo = computed(() => selectionHistory.value.length > 0)
const canRedo = computed(() => selectionRedoStack.value.length > 0)

const videoUrl = computed(() => props.videoUrl)
const mode = computed(() => props.mode)

const videoAspectStyle = computed(() => {
    if (videoWidth.value > 0 && videoHeight.value > 0) {
        return {
            aspectRatio: `${videoWidth.value} / ${videoHeight.value}`,
        }
    }
    return {
        aspectRatio: '16 / 9',
    }
})

const getVideoBounds = () => {
    if (!videoElement.value || !videoContainer.value) return null
    const videoRect = videoElement.value.getBoundingClientRect()
    const containerRect = videoContainer.value.getBoundingClientRect()

    return {
        x: videoRect.left - containerRect.left,
        y: videoRect.top - containerRect.top,
        width: videoRect.width,
        height: videoRect.height,
    }
}

const getScale = () => {
    const bounds = getVideoBounds()
    if (!bounds || !videoWidth.value || !videoHeight.value) return null
    return {
        scaleX: videoWidth.value / bounds.width,
        scaleY: videoHeight.value / bounds.height,
        bounds,
    }
}

const configureCanvas = () => {
    if (!selectionCanvas.value || !videoContainer.value) return
    const canvas = selectionCanvas.value
    const container = videoContainer.value

    // 使用容器的尺寸，与视频去水印保持一致
    canvas.width = container.clientWidth
    canvas.height = container.clientHeight
    canvasCtx = canvas.getContext('2d')
    drawCanvas()
}

const formatTime = (value: number) => {
    const minutes = Math.floor(value / 60)
    const seconds = Math.floor(value % 60)
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

const drawSelectionRect = (selection: SelectionData) => {
    if (!canvasCtx) return
    const scale = getScale()
    if (!scale) return

    const displayX = selection.spatial.x / scale.scaleX
    const displayY = selection.spatial.y / scale.scaleY
    const displayWidth = selection.spatial.width / scale.scaleX
    const displayHeight = selection.spatial.height / scale.scaleY

    // 确保绘制区域完全在视频区域内
    const x = Math.max(0, Math.min(displayX, scale.bounds.width))
    const y = Math.max(0, Math.min(displayY, scale.bounds.height))
    const maxWidth = scale.bounds.width - x
    const maxHeight = scale.bounds.height - y
    const width = Math.max(0, Math.min(displayWidth, maxWidth))
    const height = Math.max(0, Math.min(displayHeight, maxHeight))

    // 如果裁剪后的区域太小，不绘制
    if (width <= 0 || height <= 0) return

    canvasCtx.save()
    canvasCtx.fillStyle = 'rgba(255, 102, 161, 0.2)'
    canvasCtx.strokeStyle = '#ff66a1'
    canvasCtx.lineWidth = 2
    canvasCtx.strokeRect(x + scale.bounds.x, y + scale.bounds.y, width, height)
    canvasCtx.fillRect(x + scale.bounds.x, y + scale.bounds.y, width, height)
    canvasCtx.restore()
}

const drawActiveSelection = () => {
    if (!canvasCtx || !isSelecting.value) return
    const scale = getScale()
    if (!scale) return

    // 确保选择区域完全在视频区域内
    const x = Math.max(0, Math.min(currentDisplayRect.x, scale.bounds.width))
    const y = Math.max(0, Math.min(currentDisplayRect.y, scale.bounds.height))
    const maxWidth = scale.bounds.width - x
    const maxHeight = scale.bounds.height - y
    const width = Math.max(0, Math.min(currentDisplayRect.width, maxWidth))
    const height = Math.max(0, Math.min(currentDisplayRect.height, maxHeight))

    canvasCtx.save()
    canvasCtx.strokeStyle = '#66ccff'
    canvasCtx.setLineDash([6, 6])
    canvasCtx.lineWidth = 1.5
    canvasCtx.strokeRect(x + scale.bounds.x, y + scale.bounds.y, width, height)
    canvasCtx.restore()
}

const drawCanvas = () => {
    if (!selectionCanvas.value || !canvasCtx) return
    canvasCtx.clearRect(
        0,
        0,
        selectionCanvas.value.width,
        selectionCanvas.value.height
    )
    selectionHistory.value.forEach(drawSelectionRect)
    drawActiveSelection()
}

const startSelection = (event: MouseEvent) => {
    if (mode.value !== 'precision' || !videoContainer.value) return

    const scale = getScale()
    if (!scale) return

    const containerRect = videoContainer.value.getBoundingClientRect()
    const mouseX = event.clientX - containerRect.left
    const mouseY = event.clientY - containerRect.top

    // 严格检查是否在视频区域内，使用 < 和 > 而不是 <= 和 >=
    if (
        mouseX < scale.bounds.x ||
        mouseX > scale.bounds.x + scale.bounds.width ||
        mouseY < scale.bounds.y ||
        mouseY > scale.bounds.y + scale.bounds.height
    ) {
        return
    }

    const displayX = mouseX - scale.bounds.x
    const displayY = mouseY - scale.bounds.y

    selectionStartDisplay.x = displayX
    selectionStartDisplay.y = displayY
    currentDisplayRect.x = displayX
    currentDisplayRect.y = displayY
    currentDisplayRect.width = 0
    currentDisplayRect.height = 0

    currentActualRect.x = displayX * scale.scaleX
    currentActualRect.y = displayY * scale.scaleY
    currentActualRect.width = 0
    currentActualRect.height = 0

    isSelecting.value = true
    drawCanvas()
}

const onCanvasMouseMove = (event: MouseEvent) => {
    if (!isSelecting.value || !videoContainer.value) return
    const scale = getScale()
    if (!scale) return

    const containerRect = videoContainer.value.getBoundingClientRect()
    const mouseX = event.clientX - containerRect.left
    const mouseY = event.clientY - containerRect.top

    // 先转换为相对于视频区域的坐标
    const currentX = mouseX - scale.bounds.x
    const currentY = mouseY - scale.bounds.y

    // 限制在视频区域内（0 到 width/height）
    const clampedCurrentX = Math.max(0, Math.min(currentX, scale.bounds.width))
    const clampedCurrentY = Math.max(0, Math.min(currentY, scale.bounds.height))

    // 直接使用 selectionStartDisplay（已经在 startSelection 中验证在视频区域内）
    const x = Math.min(selectionStartDisplay.x, clampedCurrentX)
    const y = Math.min(selectionStartDisplay.y, clampedCurrentY)
    const width = Math.abs(clampedCurrentX - selectionStartDisplay.x)
    const height = Math.abs(clampedCurrentY - selectionStartDisplay.y)

    currentDisplayRect.x = x
    currentDisplayRect.y = y
    currentDisplayRect.width = width
    currentDisplayRect.height = height

    currentActualRect.x = x * scale.scaleX
    currentActualRect.y = y * scale.scaleY
    currentActualRect.width = width * scale.scaleX
    currentActualRect.height = height * scale.scaleY

    drawCanvas()
}

const endSelection = () => {
    if (!isSelecting.value) return
    isSelecting.value = false

    if (!currentActualRect.width || !currentActualRect.height) {
        drawCanvas()
        return
    }

    const MIN_SIZE = 8
    if (
        currentActualRect.width < MIN_SIZE ||
        currentActualRect.height < MIN_SIZE
    ) {
        drawCanvas()
        return
    }

    // 验证选择区域是否完全在视频区域内
    const scale = getScale()
    if (!scale) {
        drawCanvas()
        return
    }

    // 将实际坐标转换为显示坐标
    const displayX = currentActualRect.x / scale.scaleX
    const displayY = currentActualRect.y / scale.scaleY
    const displayWidth = currentActualRect.width / scale.scaleX
    const displayHeight = currentActualRect.height / scale.scaleY

    // 检查选择区域是否完全在视频区域内
    const isWithinBounds =
        displayX >= 0 &&
        displayY >= 0 &&
        displayX + displayWidth <= scale.bounds.width &&
        displayY + displayHeight <= scale.bounds.height

    // 如果选择区域超出视频区域，不保存
    if (!isWithinBounds) {
        drawCanvas()
        return
    }

    selectionHistory.value = [
        ...selectionHistory.value,
        {
            spatial: { ...currentActualRect },
            timestamp: Date.now(),
        },
    ]
    selectionRedoStack.value = []
    drawCanvas()
}

// 触摸事件处理函数 - 开始框选
const startSelectionTouch = (event: TouchEvent) => {
    if (mode.value !== 'precision' || !videoContainer.value) return

    const touch = event.touches[0]
    if (!touch) return

    const scale = getScale()
    if (!scale) return

    const containerRect = videoContainer.value.getBoundingClientRect()
    const touchX = touch.clientX - containerRect.left
    const touchY = touch.clientY - containerRect.top

    // 严格检查是否在视频区域内
    if (
        touchX < scale.bounds.x ||
        touchX > scale.bounds.x + scale.bounds.width ||
        touchY < scale.bounds.y ||
        touchY > scale.bounds.y + scale.bounds.height
    ) {
        return
    }

    const displayX = touchX - scale.bounds.x
    const displayY = touchY - scale.bounds.y

    selectionStartDisplay.x = displayX
    selectionStartDisplay.y = displayY
    currentDisplayRect.x = displayX
    currentDisplayRect.y = displayY
    currentDisplayRect.width = 0
    currentDisplayRect.height = 0

    currentActualRect.x = displayX * scale.scaleX
    currentActualRect.y = displayY * scale.scaleY
    currentActualRect.width = 0
    currentActualRect.height = 0

    isSelecting.value = true
    drawCanvas()
}

// 触摸事件处理函数 - 移动框选
const onCanvasTouchMove = (event: TouchEvent) => {
    if (!isSelecting.value || !videoContainer.value) return

    const touch = event.touches[0]
    if (!touch) return

    const scale = getScale()
    if (!scale) return

    const containerRect = videoContainer.value.getBoundingClientRect()
    const touchX = touch.clientX - containerRect.left
    const touchY = touch.clientY - containerRect.top

    // 先转换为相对于视频区域的坐标
    const currentX = touchX - scale.bounds.x
    const currentY = touchY - scale.bounds.y

    // 限制在视频区域内
    const clampedCurrentX = Math.max(0, Math.min(currentX, scale.bounds.width))
    const clampedCurrentY = Math.max(0, Math.min(currentY, scale.bounds.height))

    const x = Math.min(selectionStartDisplay.x, clampedCurrentX)
    const y = Math.min(selectionStartDisplay.y, clampedCurrentY)
    const width = Math.abs(clampedCurrentX - selectionStartDisplay.x)
    const height = Math.abs(clampedCurrentY - selectionStartDisplay.y)

    currentDisplayRect.x = x
    currentDisplayRect.y = y
    currentDisplayRect.width = width
    currentDisplayRect.height = height

    currentActualRect.x = x * scale.scaleX
    currentActualRect.y = y * scale.scaleY
    currentActualRect.width = width * scale.scaleX
    currentActualRect.height = height * scale.scaleY

    drawCanvas()
}

const clearSelections = () => {
    selectionHistory.value = []
    selectionRedoStack.value = []
    drawCanvas()
}

const undoSelection = () => {
    if (!canUndo.value) return
    const last = selectionHistory.value.pop()
    if (last) {
        selectionRedoStack.value.push(last)
        drawCanvas()
    }
}

const redoSelection = () => {
    if (!canRedo.value) return
    const restored = selectionRedoStack.value.pop()
    if (restored) {
        selectionHistory.value.push(restored)
        drawCanvas()
    }
}

const togglePlayPause = () => {
    if (!videoElement.value) return
    if (videoElement.value.paused) {
        videoElement.value.play()
    } else {
        videoElement.value.pause()
    }
}

const updateVideoProgress = () => {
    if (!videoElement.value) return
    const current = videoElement.value.currentTime
    currentTime.value = formatTime(current)
    videoProgressPercent.value = videoElement.value.duration
        ? (current / videoElement.value.duration) * 100
        : 0
}

const handleProgressClick = (event: MouseEvent) => {
    if (!videoElement.value || !videoElement.value.duration) return
    const target = event.currentTarget as HTMLElement
    const rect = target.getBoundingClientRect()
    const percent = Math.min(
        Math.max((event.clientX - rect.left) / rect.width, 0),
        1
    )
    videoElement.value.currentTime = videoElement.value.duration * percent
    updateVideoProgress()
}

const startDrag = (event: MouseEvent) => {
    if (!videoElement.value || !videoElement.value.duration) return
    event.preventDefault()
    isDragging.value = true

    const track = (event.currentTarget as HTMLElement).parentElement
    if (!track) return
    const trackRect = track.getBoundingClientRect()

    dragMoveHandler = (moveEvent: MouseEvent) => {
        if (!isDragging.value || !videoElement.value) return
        const offset = Math.min(
            Math.max(moveEvent.clientX - trackRect.left, 0),
            trackRect.width
        )
        const percent = offset / trackRect.width
        videoElement.value.currentTime = videoElement.value.duration * percent
        updateVideoProgress()
    }

    dragUpHandler = () => {
        isDragging.value = false
        if (dragMoveHandler)
            document.removeEventListener('mousemove', dragMoveHandler)
        if (dragUpHandler)
            document.removeEventListener('mouseup', dragUpHandler)
        dragMoveHandler = null
        dragUpHandler = null
    }

    document.addEventListener('mousemove', dragMoveHandler)
    document.addEventListener('mouseup', dragUpHandler)
}

const onVideoLoaded = () => {
    if (!videoElement.value) return
    videoWidth.value = videoElement.value.videoWidth
    videoHeight.value = videoElement.value.videoHeight

    if (videoElement.value.duration) {
        videoDuration.value = Math.ceil(videoElement.value.duration)
        totalTime.value = formatTime(videoElement.value.duration)
    } else {
        totalTime.value = '00:00'
    }

    currentTime.value = formatTime(0)
    videoProgressPercent.value = 0

    nextTick(() => configureCanvas())
}

const syncSelections = () => {
    if (props.selections && props.selections.length) {
        selectionHistory.value = props.selections.map(item => ({
            spatial: { ...item.spatial },
            timestamp: item.timestamp,
        }))
    } else {
        selectionHistory.value = []
    }
    selectionRedoStack.value = []
    drawCanvas()
}

const handleConfirm = () => {
    emit('confirm', {
        selections: mode.value === 'precision' ? selectionHistory.value : [],
        duration: videoDuration.value,
    })
    visibleModel.value = false
}

const handleClose = () => {
    visibleModel.value = false
}

watch(
    () => props.visible,
    value => {
        if (value) {
            nextTick(() => {
                syncSelections()
                configureCanvas()
            })
        } else {
            if (videoElement.value) {
                videoElement.value.pause()
                videoElement.value.currentTime = 0
                updateVideoProgress()
            }
        }
    }
)

watch(
    () => props.videoUrl,
    () => {
        selectionHistory.value = []
        selectionRedoStack.value = []
        nextTick(() => configureCanvas())
    }
)

watch(
    () => props.mode,
    () => {
        if (mode.value !== 'precision') {
            selectionHistory.value = []
            selectionRedoStack.value = []
        }
        nextTick(() => drawCanvas())
    }
)

onMounted(() => {
    // 检测移动端
    checkMobile()
    if (typeof window !== 'undefined') {
        window.addEventListener('resize', checkMobile)
    }

    if (videoContainer.value && 'ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(() => {
            configureCanvas()
        })
        resizeObserver.observe(videoContainer.value)
    }
})

onBeforeUnmount(() => {
    // 移除窗口大小变化监听
    if (typeof window !== 'undefined') {
        window.removeEventListener('resize', checkMobile)
    }

    if (resizeObserver && videoContainer.value) {
        resizeObserver.unobserve(videoContainer.value)
    }
    if (dragMoveHandler)
        document.removeEventListener('mousemove', dragMoveHandler)
    if (dragUpHandler) document.removeEventListener('mouseup', dragUpHandler)
})
</script>

<style lang="less">
/* 全局样式覆盖 Element Plus Dialog */
.subtitle-selection-dialog-modal {
    .el-dialog {
        display: flex;
        flex-direction: column;
        max-height: 90vh;
    }

    .el-dialog__body {
        padding: 0 24px 24px !important;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .el-dialog__header {
        flex-shrink: 0;
        padding-bottom: 0px;
    }

    .el-dialog__footer {
        flex-shrink: 0;
    }

    .el-button {
        border-radius: 10px !important;
        padding: 11px 28px !important;

        &:hover {
            background-color: unset;
            border-color: #99f768;
        }
    }

    @media (max-width: 768px) {
        .el-dialog.is-align-center {
            padding: 0 !important;
            margin: 0;
            max-height: 100vh;
            width: 100% !important;
        }

        .el-dialog__footer {
            padding: 14px 21px !important;
            border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
        }

        .el-button {
            font-size: 10px !important;
        }
    }
}
</style>

<style scoped lang="less">
.subtitle-selection-dialog {}

.dialog-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 500px;
    max-height: 85vh;
    height: 85vh;
}

.editor-toolbar {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0;
    flex-shrink: 0;
}

.toolbar-group {
    display: flex;
    gap: 12px;
}

.toolbar-icon-btn {
    width: 48px;
    height: 48px;
    padding: 0;
    border: none;
    background: transparent;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.08);
        border-radius: 8px;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    svg {
        flex-shrink: 0;
    }
}

.toolbar-text-btn {
    height: 48px;
    padding: 0 16px;
    border: none;
    background: transparent;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    white-space: nowrap;

    &:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.08);
        border-radius: 8px;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    svg {
        flex-shrink: 0;
    }
}

.video-preview {
    flex: 1;
    border-radius: 12px;
    overflow: hidden;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
}

.video-frame-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
    display: block;
}

.selection-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: crosshair;
    z-index: 15;
}

.video-controls-bar {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0 8px;
    flex-shrink: 0;
}

.play-pause-btn {
    border: none;
    background: transparent;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.control-icon {
    flex-shrink: 0;
}

.custom-progress-bar {
    flex: 1;
    position: relative;
    height: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.progress-track {
    position: relative;
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.28);
}

.progress-fill {
    height: 100%;
    border-radius: 2px;
    background: rgba(255, 94, 183, 0.6);
}

.progress-thumb {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #fff;
    cursor: grab;

    &:active {
        cursor: grabbing;
    }
}

.progress-text,
.progress-time {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.78);
}

.selection-summary {
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 12px 18px;
    flex-shrink: 0;
    height: 100px;
    overflow-y: auto;
}

.summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
}

.summary-empty {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    padding: 8px 0;
}

.summary-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 150px;
    overflow-y: auto;
}

.summary-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.35);
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
}

.summary-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.08);
    font-weight: 600;
}

.summary-coords {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    :deep(.el-button--primary) {
        color: #000000 !important;
        font-weight: 400;
        font-family: Roboto;
        font-size: 14px;

        &:hover,
        &:focus,
        &:active {
            background: var(--el-color-primary) !important;
            border-color: var(--el-color-primary) !important;
            color: #000000 !important;
        }
    }
}

.mobile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 14px 21px;
    background: #121214;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.mobile-header-left {
    flex-shrink: 1;
    min-width: 0;
}

.mobile-title {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mobile-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.mobile-toolbar {
    display: flex;
    gap: 4px;

    .toolbar-icon-btn {
        width: 32px;
        height: 32px;
    }

    .toolbar-text-btn {
        height: 32px;
        padding: 0 8px;
        font-size: 12px;
        gap: 4px;

        .icon {
            width: 16px;
            height: 16px;
        }
    }
}

.mobile-close-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    color: #fff;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.2s ease;
    flex-shrink: 0;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
}

@media (max-width: 768px) {
    .dialog-body {
        max-height: 80vh;
        height: 80vh;
        gap: 12px;
    }

    .video-preview {
        border-radius: 8px;
    }

    .toolbar-icon-btn {
        width: 40px;
        height: 40px;
    }

    .toolbar-text-btn {
        height: 40px;
        padding: 0 12px;
        font-size: 13px;
    }

    .selection-summary {
        gap: 0;
        padding: 0px;
        border-radius: 0;
        background: transparent;
    }

    .summary-header {
        padding: 10px 0;
    }

    .summary-list {
        max-height: 100px;
    }
}

.icon {
    width: 20px;
    height: 20px;
    display: inline-block;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
    mask-size: contain;
}

.i-go-icon {
    mask: url('~/assets/images/icons/go.svg') no-repeat center;
    -webkit-mask: url('~/assets/images/icons/go.svg') no-repeat center;
}

.i-back-icon {
    mask: url('~/assets/images/icons/back.svg') no-repeat center;
    -webkit-mask: url('~/assets/images/icons/back.svg') no-repeat center;
}

.i-clear-all-icon {
    mask: url('~/assets/images/icons/clear-all.svg') no-repeat center;
    -webkit-mask: url('~/assets/images/icons/clear-all.svg') no-repeat center;
}
</style>
